module.exports = __webpack_public_path__ + "static/img/img_4.992397ca.jpg";